import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../../generic.service';
import { PaymentReportRequest, PaymentReportResponse } from '../../../models/paymentreport.model';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {
    constructor(private genericService: GenericService) { }

    paymentReport(request: PaymentReportRequest): Observable<PaymentReportResponse> {
        return this.genericService.post<PaymentReportResponse>('report', request);
    }
}

